import { render } from "./OrderManagement.vue?vue&type=template&id=0fa1bbd4&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"

import "./OrderManagement.vue?vue&type=style&index=0&id=0fa1bbd4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa1bbd4"]])

export default __exports__